import React from 'react'

export const useIsDocumentLoaded = () => {
  const [isDocumentLoaded, setIsDocumentLoaded] = React.useState(false)

  React.useEffect(() => {
    const callback = () => {
      setIsDocumentLoaded(true)
    }

    if (document.readyState === 'complete') {
      setIsDocumentLoaded(true)
    } else {
      window.addEventListener('load', callback)
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', callback)
    }
  }, [])

  return isDocumentLoaded
}
